import { styled } from '@slicknode/stylemapper';

export const Divider = styled('div', 'bg-base200 h-[1px] w-full mb-4', {
  variants: {
    orientation: {
      horizontal: 'h-[1px] w-full',
      vertical: 'w-[1px] h-full',
    },
  },
  defaultVariants: {
    orientation: 'horizontal',
  },
});
